import React, { useRef, useState } from 'react';
import { PopupContainer } from '../../LactoMamaPage/LactoMamaPageOuter/styled';
import {
  checkVarient,
  fireProductActionEvent,
  getCartButton,
  goToCartForCategoryPage,
  productActionClick,
} from '../../../Utils/productAction';
import SizeAndPacksCover from '../SizeAndPacksCover';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { mutate } from 'swr';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import HealthBundle from '../HealthBundle/HealthBundle';

const VariantBottomPopup = (props) => {
  const {
    productData,
    showSizePopup,
    setShowSizePopup,
    setShowFadeEffect,
    setAddedToCart,
    showNewDiaperVariantUx,
    isVariantPopup,
    fromSizePopup,
    showanimation,
    closeModalPopup,
    handleClose,
    isDetergentProduct,
    isFertilityProduct,
  } = props;

  const mobileButtonRef = useRef();
  const [loaderState, setLoaderState] = useState('');
  const [loaderGoToCart, setLoaderGoToCart] = useState('');

  const variantType =
    productData?.variantOption?.find((option) => option.variant_type !== 'Size')
      ?.variant_type || '';

  const { data } = useGetCartData();

  const [cartButton, setCartButton] = useState(getCartButton(productData?.id));

  const showLoadingScreen = (loaderState, isExp) => {
    return (
      <CssLoader
        className={loaderState === 'loaded' ? 'load-complete' : ''}
        theme="#fff"
        aplusplus={isExp}
      >
        <div
          className="checkmark draw"
          style={loaderState === 'loaded' ? { display: 'block' } : {}}
        ></div>
      </CssLoader>
    );
  };
  const addGoToCart = async () => {
    fireProductActionEvent('clicked_add_to_cart', productData);
    if (cartButton == 1) {
      if (checkVarient()) {
        if (fromSizePopup == undefined) {
          showSizePopup(true);
          return true;
        } else {
          showanimation(true);
          return true;
        }
      }
      setLoaderState('loading');
      //1:"ADD TO CART",2:"GO TO CART"
      if (data) {
        await mutate('/api/getNewCartAmountOfUserWeb', null, false);
      }
      const apiResponse = await productActionClick(
        'cart',
        productData,
        cartButton,
        showSizePopup,
      );
      if (apiResponse == true) {
        setAddedToCart(true);
        setLoaderGoToCart('');
        setTimeout(() => {
          setCartButton(2); //1:"ADD TO CART",2:"GO TO CART"
        }, 800);
        setLoaderState('loaded');
      } else {
        setLoaderState('');
        setCartButton(1);
      }
    } else {
      setLoaderGoToCart('loading');
      const apiResponse = await goToCartForCategoryPage(
        productData,
        fromSizePopup,
        closeModalPopup,
      );
      if (apiResponse == true) {
        setLoaderState('');
        setLoaderGoToCart('loaded');
        setTimeout(() => {
          setLoaderGoToCart('');
        }, 800);
      } else {
        setLoaderState('');
      }
    }
    if (isVariantPopup) {
      handleClose();
    }
  };
  return (
    <PopupContainer>
      <h4>Choose your {variantType}</h4>
      <div className="seperator" />

      {productData?.variantOption.length &&
        !productData?.isWebBundle &&
        !isFertilityProduct &&
        !isDetergentProduct && (
          <SizeAndPacksCover
            showSizePopup={showSizePopup}
            setShowSizePopup={setShowSizePopup}
            productData={productData}
            setShowFadeEffect={setShowFadeEffect}
            setAddedToCart={setAddedToCart}
            showNewDiaperVariantUx={showNewDiaperVariantUx}
            isVariantPopup={isVariantPopup}
            handleClose={handleClose}
          />
        )}

      {(productData?.isWebBundle ||
        isFertilityProduct ||
        isDetergentProduct) && (
        <HealthBundle
          productId={productData?.id}
          data={productData?.variantData.filter((obj) => obj.id != 3960)}
          isFertilityProduct={isFertilityProduct}
          isPopUp={isVariantPopup}
          handleClose={handleClose}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          onClick={() => addGoToCart()}
          style={{
            background: '#ef4e5e',
            color: '#fff',
            border: '#ef4e5e',
            borderRadius: '8px',
            height: '50px',
            fontSize: '15px',
            fontWeight: '600',
            textAlign: 'center',
            margin: '2px 12px',
            width: '100%',
            fontFamily: 'Montserrat',
            cursor: 'pointer',
            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 2px 0px',
          }}
        >
          {cartButton == 1
            ? loaderState === 'loading' || loaderState === 'loaded'
              ? showLoadingScreen(loaderState)
              : 'ADD TO CART'
            : loaderGoToCart === 'loading' || loaderGoToCart === 'loaded'
              ? showLoadingScreen(loaderGoToCart)
              : 'GO TO CART'}
          <span></span>
        </button>
      </div>
    </PopupContainer>
  );
};

export default VariantBottomPopup;
